// Layouts that are always noindex (auth-gated / functional pages).
// These pages must not emit hreflang or x-default.
export const NOINDEX_LAYOUTS = ['account'];

/**
 * Whether a page layout is inherently noindex.
 *
 * @param {string} [layout]
 * @return {boolean}
 */
export const isNoindexLayout = layout => NOINDEX_LAYOUTS.includes(layout);

/**
 * Resolve the final noindex state for a page.
 * CMS meta drives it (`content.seo[0].index === 'no_index'`); `forced`
 * covers sources the CMS meta can't see (e.g. auth-gated account pages).
 *
 * @param {string} [cmsIndex] value of content.seo[0].index ('index' | 'no_index' | undefined)
 * @param {boolean} [forced]
 * @return {boolean}
 */
export const resolveNoindex = (cmsIndex, forced = false) => cmsIndex === 'no_index' || forced;
